<template>
  <div class="element-input element-textbox element-textbox-auto-calculate element-textbox-have-price" :class="{ disabled }">
    <div class="container">
      <div class="label" @click="clickHelp">
        <p>
          <span :class="{ active: dropbox && statusHelp }">{{ label }}</span>
          <img v-if="dropbox" :src="statusHelp ? '../static/cancel_blue.png' : '../static/help_gray.png'" />

        </p>
        <div class="dropbox" v-if="dropbox && statusHelp">
          {{ dropbox }}
        </div>
      </div>

      <div class="body">
        <input type="text" v-model="model" :disabled="disabled" :placeholder="placeholder" />
        <label class="back">만원</label>
      </div>
      <div class="error" v-if="error">{{ error }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: [ "value", "label", "type", "mode", "year", "error", "disabled", "placeholder", "dropbox" ],
  created() {
  },
  data(){
    return {
      statusHelp: false,
    }
  },
  computed: {
    model: {
      get(){
        return this.value;
      },
      set( value ){
        this.$emit( "input", value );
      }
    }
  },
  created() {

  },
  methods: {
    selectItem( value ){
      this.$emit( "input", value );
    },

    clickHelp(){
      this.statusHelp = !this.statusHelp
    },

  }

}
</script>
